import styled from "@emotion/styled";

export const EmptyStateContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;
